import { request } from "./ApiService";

export const refreshImages = (imageId: string) =>
  document.querySelectorAll(`img[src*='${imageId}']`).forEach(img => img.setAttribute("src", img.getAttribute("src") + "&t=" + new Date().getTime()));
export const refreshVideos = () => document.querySelectorAll("video").forEach(x => x.load());
export const convertVideo = async (videoId: string) => request(`convert/video/${videoId}`, { method: "POST" });
